import { apiSlice } from './apiSlice';

const SEASONS_URL = '/api/seasons';

export const seasonsApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    // Get current season for a league
    getCurrentSeason: builder.query({
      query: (leagueId) => ({
        url: `${SEASONS_URL}/current/${leagueId}`,
        method: 'GET',
      }),
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
      refetchOnReconnect: true,
      providesTags: ['Season'],
    }),
    
    // Get all seasons for a league
    getLeagueSeasons: builder.query({
      query: (leagueId) => ({
        url: `${SEASONS_URL}/league/${leagueId}`,
        method: 'GET',
      }),
      refetchOnMountOrArgChange: true,
      refetchOnFocus: true,
      refetchOnReconnect: true,
      providesTags: ['Season'],
    }),
    
    // Get season leaderboard
    getSeasonLeaderboard: builder.query({
      query: (seasonId) => ({
        url: `${SEASONS_URL}/leaderboard/${seasonId}`,
        method: 'GET',
      }),
      providesTags: ['Season', 'Leaderboard'],
    }),
    
    // Create next season
    createNextSeason: builder.mutation({
      query: ({ leagueId, startDate }) => ({
        url: `${SEASONS_URL}/create-next/${leagueId}`,
        method: 'POST',
        body: { startDate },
      }),
      invalidatesTags: ['Season'],
    }),
    
    // End season
    endSeason: builder.mutation({
      query: (seasonId) => ({
        url: `${SEASONS_URL}/end/${seasonId}`,
        method: 'POST',
      }),
      invalidatesTags: ['Season'],
    }),
    
    // Update season statuses
    updateSeasonStatuses: builder.mutation({
      query: () => ({
        url: `${SEASONS_URL}/update-statuses`,
        method: 'POST',
      }),
      invalidatesTags: ['Season'],
    }),
  }),
});

export const {
  useGetCurrentSeasonQuery,
  useGetLeagueSeasonsQuery,
  useGetSeasonLeaderboardQuery,
  useCreateNextSeasonMutation,
  useEndSeasonMutation,
  useUpdateSeasonStatusesMutation,
} = seasonsApiSlice;
